import React from 'react';
import { ChevronUpIcon, ChevronDownIcon, XIcon } from 'lucide-react';
interface ItemRowProps {
  children: React.ReactNode;
  /** Leading visual — icon tile or thumbnail. */
  lead?: React.ReactNode;
  onUp?: () => void;
  onDown?: () => void;
  onRemove?: () => void;
  /** Replaces the remove button (e.g. a show/hide switch). */
  trailing?: React.ReactNode;
  /** Tapping the body opens it for editing. */
  onEdit?: () => void;
  muted?: boolean;
  label: string;
}

/**
 * One tidy row for any list the merchant orders: tap to edit, small arrows to
 * reorder, one quiet remove. No drag handles, no pencil icons to decode.
 */
export function ItemRow({
  children,
  lead,
  onUp,
  onDown,
  onRemove,
  trailing,
  onEdit,
  muted,
  label
}: ItemRowProps) {
  const body = <span className={`flex-1 min-w-0 flex items-center gap-3 ${muted ? 'opacity-50' : ''}`} data-id="element-3505" data-mp="2xq4cjmf9s8d">
      {lead}
      <span className="flex-1 min-w-0" data-id="element-3506" data-mp="3u4apjmpsq5xh">{children}</span>
    </span>;
  return <div className="group flex items-center gap-1 pl-3 pr-1.5 py-2 rounded-xl bg-white ring-1 ring-slate-200/80 hover:ring-slate-300 transition-shadow duration-150 ease-out" data-id="element-3507" data-mp="3u6dowxcu9bev">
      {onEdit ? <button type="button" onClick={onEdit} className="flex-1 min-w-0 flex text-left" aria-label={`Edit ${label}`} data-id="element-3508" data-mp="y9odnqy9p0v">
          {body}
        </button> : body}
      {(onUp || onDown) && <span className="flex flex-col -my-1 flex-shrink-0" data-id="element-3509" data-mp="foqrrcn5ap0e">
          <button type="button" onClick={onUp} disabled={!onUp} aria-label={`Move ${label} up`} className="p-0.5 rounded text-slate-300 hover:text-dark-navy disabled:opacity-30 disabled:hover:text-slate-300 transition-colors duration-150 ease-out" data-id="element-3510" data-mp="ko3mejk9d0dj">
            <ChevronUpIcon className="w-3.5 h-3.5" data-id="element-3511" data-mp="2qims40qkk78o" />
          </button>
          <button type="button" onClick={onDown} disabled={!onDown} aria-label={`Move ${label} down`} className="p-0.5 rounded text-slate-300 hover:text-dark-navy disabled:opacity-30 disabled:hover:text-slate-300 transition-colors duration-150 ease-out" data-id="element-3512" data-mp="2vgei2p7nlja8">
            <ChevronDownIcon className="w-3.5 h-3.5" data-id="element-3513" data-mp="bnxcgndnaokp" />
          </button>
        </span>}
      {trailing ?? (onRemove && <button type="button" onClick={onRemove} aria-label={`Remove ${label}`} className="p-1.5 rounded-lg text-slate-300 hover:text-error hover:bg-error/[0.06] transition-colors duration-150 ease-out flex-shrink-0" data-id="element-3514" data-mp="6pvxoen95bf1">
            <XIcon className="w-4 h-4" data-id="element-3515" data-mp="ucubf4jzm599" />
          </button>)}
    </div>;
}